/**
 * Created by mac on 7/23/25
 */

const TreasureSearchMerge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_TREASURE_SEARCH) {
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
                cleverapps.eventBus.trigger("merge2CustomersForceUpdateReward");
            }
        });

        cleverapps.missionManager.on("complete", (mission) => {
            if (mission.getType() === Mission.TYPE_TREASURE_SEARCH) {
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
                cleverapps.eventBus.trigger("merge2CustomersForceUpdateReward");
            }
        });
    }
};

cleverapps.whenAllInitialized(() => TreasureSearchMerge2Adapter.SubscribeToEvents());